module.exports = __webpack_public_path__ + "static/fonts/HelveticaNeueCyr-Medium.e9b004b.woff";